import { Fragment, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from './index';
import { urlWithParams } from '../../../services/Util';

export default function Modal(props) {
	const { onClick: onClickTrack, id: buttonId, label, value } = props;

	const { __ } = wp.i18n;

	const history = useHistory();

	if (!label || !label.length || !value || !value.length) {
		return false;
	}

	let newProps = { ...props };

	newProps.onClick = (e) => {
		e.preventDefault();
		onClickTrack(false, buttonId);
		history.push(urlWithParams({ m: 'modal', bid: buttonId }));
		return false;
	};

	return (
		<Fragment>
			<Button {...newProps} />
		</Fragment>
	);
}
